import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import AJAX from "../functions/ajax";

import AppHOC from "../hoc/AppHOC";

import BaseFormio from "../components/forms/BaseFormio";

export class FormPreview extends Component {
  _id = Math.random();

  state = {
    form: null,
  };

  componentDidMount() {
    document.body.classList.add("u-bg-transparent");

    AJAX()
      .get(this._id, `/api/form_preview/${this.props.match.params.fieldset_id}`)
      .then(res => {
        this.setState({ form: res.data });
      });
  }

  render() {
    if (!this.props.info || !this.state.form) return null;

    return (
      <AppHOC>
        <div id="page">
          <div className="rowCon rowCon__withMargin" id="main_content">
            <div className="dashboardMain">
              <BaseFormio
                schema={this.state.form}
                options={this.props.info.default_formio_options}
              />
            </div>
          </div>
        </div>
      </AppHOC>
    );
  }
}

const mapStateToProps = store => ({
  info: store.app.info,
});

export default connect(mapStateToProps)(injectIntl(FormPreview));
